const get = require('lodash/get');
const assign = require('lodash/assign');
const format = require('@flowio/lib-reference-javascript/lib/format');
const session = require('@flowio/session');

/**
 * Localize amount based on country or locale
 *
 * Will default to using the country associated to the current session
 *
 * @param  {Number} amount  value of money (not in cents)
 * @param  {Object} options
 * @param  {Object} options.locale Optional. the locale in which to localize amount
 */
function currency(amount, options) {
  const opts = assign({ locale: session.getLocale() }, options);
  const formatSettings = session.getFormat && session.getFormat();
  return format.currency(amount, opts.locale, get(formatSettings, 'currency'));
}

module.exports = {
  currency,
};



// WEBPACK FOOTER //
// ./static/js/v0/format.js